type NumberGroup = number | number[] | string

export interface PartitionedThaiLottoGroup {
  group: NumberGroup
  originalIndex: number
}

export const partitionThaiLottoGroups = (
  groups: NumberGroup[],
): PartitionedThaiLottoGroup[] => {
  const flat: PartitionedThaiLottoGroup[] = []
  const nested: PartitionedThaiLottoGroup[] = []
  groups.forEach((group, originalIndex) => {
    if (Array.isArray(group)) {
      nested.push({ group, originalIndex })
    } else {
      flat.push({ group, originalIndex })
    }
  })
  return [...flat, ...nested]
}
